import { flexbox } from './flexbox.css';

type Flexbox = Parameters<typeof flexbox>[0];

export type FlexboxProps = {
  direction?: Flexbox['flexDirection']; // e.g, type is "column"|"row"|undefined
  wrap?: Flexbox['flexWrap'];
};

const flexboxInterpolations = {
  direction: ({ direction }: Pick<FlexboxProps, 'direction'>) =>
    direction === undefined
      ? {}
      : {
          class: flexbox({ direction })
        },
  wrap: ({ wrap }: Pick<FlexboxProps, 'wrap'>) =>
    wrap === undefined
      ? {}
      : {
          class: flexbox({ wrap })
        }
};

export { flexboxInterpolations };
